import React from 'react';
import ListPanel from '@/components/ListPanel';
import K8sTable from './K8sTable';

export default function K8sList() {
  return (
    <ListPanel
      header='K8S集群管理'
      tip='通过k8s config信息添加集群信息，pulsar集群将会部署该机群上。'
    >
      <K8sTable />
    </ListPanel>
  );
}
